@if (error) {
  <ion-card color="danger"><ion-card-content>{{ error }}</ion-card-content></ion-card>
}

@if (loading) {
  <ion-spinner></ion-spinner>
}

@if (safeHtml) {
  <div [innerHTML]="safeHtml"></div>
}
